import { getBanner } from '@/calls/banner';

const banner = {
  namespaced: true,
  state: {
    requests: 0,
    item: null,
    bannerHeight: 0,
    display: false,
  },
  mutations: {
    setItem(state, item) {
      state.item = item;
    },
    setBannerHeight(state, height) {
      state.bannerHeight = height;
    },
    setDisplay(state, flag) {
      state.display = flag;
    },
    closeBanner(state) {
      localStorage.setItem('banner-closed', true);
      localStorage.setItem('banner-title', state.item.title);
      state.display = false;
    },
    increaseRequests(state) {
      state.requests += 1;
    },
    decreaseRequests(state) {
      state.requests -= 1;
    }
  },
  actions: {
    async get({ commit }) {
      commit('increaseRequests');
      const request = await getBanner();
      if (request.success) {
        commit('setItem', request.data);

        const bannerClosed = localStorage.getItem('banner-closed');
        const bannerTitle = localStorage.getItem('banner-title');

        if (bannerTitle !== request.data.title) {
          localStorage.removeItem('banner-closed');
        }

        const today = new Date().setHours(0, 0, 0, 0);
        const start = new Date(request.data.start.replace(/-/g, '/')).setHours(0, 0, 0, 0);
        const end = new Date(request.data.end.replace(/-/g, '/')).setHours(0, 0, 0, 0);

        if (start <= today && end >= today && !bannerClosed) {
          commit('setDisplay', true);
        }
      }
      commit('decreaseRequests');
    }
  }
};

export default banner;
